namespace advisorop.components.advisor {

    export class PopSalesforceCaseController {
        // bindings inherited from modal resolve
        salesforceCase: domains.ISalesforceCaseTrackerData;
        instanceUrl: string;

        static $inject = ["$scope"];
        constructor(
            private $scope: ng.IScope
        ) {
        }

        // url to the case record in Salesforce.
        // instanceUrl is the API host (e.g. https://<org>.my.salesforce.com); the bare
        // record-id path auto-redirects to the correct record page in Classic or Lightning.
        get caseUrl(): string {
            if (!this.instanceUrl || !this.salesforceCase) return "";
            return `${this.instanceUrl}/${this.salesforceCase.id}`;
        }

        // default modal methods
        cancel = () => {
            this.$scope.$parent.$uibModalInstance.dismiss();
        };

        // overrides
        $onInit(): void {
            const $resolve = this.$scope.$parent.$resolve;

            this.salesforceCase = $resolve.salesforceCase;
            this.instanceUrl = $resolve.instanceUrl;
        }
    }

    class PopSalesforceCase implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
            };
            this.controller = PopSalesforceCaseController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/pop-salesforce-case.html";
        }

    }
    angular.module(Constants.APP).component("popSalesforceCase", new PopSalesforceCase());
}
